module.exports = __webpack_public_path__ + "static/media/img-01.54c7420b.jpg";